module.exports = __webpack_public_path__ + "static/media/md-nuclear.486b196a.svg";